<template>
<div>
   <b-row class="" v-if="mse_warning" style="color:white;">
     Your device cannot play this recorded content.
   </b-row>
   <b-row class="" style="position:relative" v-if="!mse_warning">
     <b-col sm="12">
      <div class="arccontainer">
        <div class="arcplay" ref="arcplay">
        </div>
        <div ref="el_arcctrl" v-show="player"
          class="arcctrl">
          <div style="height:calc( 100% - 2rem - 20px );"
            @click="doPlayPause">
             <div v-if="show_info" class="vinfo">
               <div class="vinfo-seg" > {{ cur_seg_name }} </div>
               <div class="vinfo-person" v-for="per in cur_people">
                  {{ per.dname }}
               </div>
             </div>
             <div class="bigmat"
               v-if="paused && pbmode == 'seek'">
               play_arrow
             </div>
          </div>
          <div class="pbrow">
             <button class="pbitem pbmat"
               title="Play"
               @click="doPlay"
               v-if="paused">
               play_arrow
             </button>
             <button class="pbitem pbmat"
               title="Pause"
               @click="doPause"
               v-if="!paused">
               pause
             </button>
             <button class="pbitem pbsub" style="color:white;"
               title="Hide subtitles"
               v-if="subtitles.has && subtitles.show"
               @click="toggleSub">
               subtitles
             </button>
             <button class="pbitem pbsub"
               title="Show subtitles"
               v-if="subtitles.has && !subtitles.show"
               @click="toggleSub">
               subtitles_off
             </button>
             <button ref="el_live" class="pbitem pblive"
               v-if="src && !src.done"
               @click="doLive">
               LIVE
             </button>
             <button class="pbitem"
               v-if="qna"
               @click="qna"
               >
                <svg class="vxic vxic-hd" viewBox="0 0 48 48"><path d="M8.85,15.65a4.15,4.15,0,1,1,5.88-5.87l3,3-1.55-1.54a4.16,4.16,0,1,1,5.88-5.88l3,3-.32-.33a4.17,4.17,0,0,1,.5-6.35,4.33,4.33,0,0,1,5.52.62L43.32,14.86c5.59,5.59,3.92,16.53-4,24.2a23,23,0,0,1-8.24,5.23l-.14.05a18.59,18.59,0,0,1-18.61-4c-2.49-2.25-4.95-4.67-5.29-5.72a4.13,4.13,0,0,1,2.68-5.23l1,0,5,4.91L2.35,20.9a4.33,4.33,0,0,1-.62-5.52,4.17,4.17,0,0,1,6.35-.5L11.21,18" stroke-linecap="round" stroke-linejoin="round"/></svg>
             </button>
             <span ref="el_at" class="pbitem pbelp"> </span>
             <span class="pbitem pbcore">
               <canvas ref="progbar" style="max-width:100%;"> </canvas>
               <div ref="seekhov" class="seekhover"> </div>
             </span>
             <span ref="el_total" class="pbitem pbelp"> </span>
          </div>
          <div class="pbmsg">
             <span class="txtdone"
               v-if="src && src.done"
               >
               This recording has completed.
             </span>
          </div>
        </div>
      </div>
     </b-col>
   </b-row>

</div>
</template>

<script>

import ap from "../arc";

export default {
  name: "ArcPlayer",
  props: ['src','qna'],
  components: {
  },
  watch: {
    src : {
       handler : function(to, from) {
          if (this.player) {
             this.player.destroy();
             this.player = null;
          }
          if (to && to.handle) {
             this.playArchive();
          }
       },
    },
    is_live: {
      handler : function(to, from) {
        if (this.$refs.el_live) {
           this.$refs.el_live.setAttribute("enabled",to);
        }
      }
    },
  },
  data() {
    return  {
      mse_warning: false,
      player:null,
      paused:true,
      is_live:false,
      at: "",
      total: "",
      prev_at: 0,
      is_audio_only: false,
      dur: 0,
      show_info: false,
      cur_seg_name: "",
      cur_people: [],
      pbmode: "seek",
      subtitles: {has:false,show:false},
    };
  },
  computed: {
  },
  created() {
    let vue = this;
  },
  mounted() {
    let vue = this;
    window.vx_nav_callback("unmute_cbs",{
      do_mute: vue.doMute,
      do_unmute: vue.doUnmute,
    });
    if (vue.$refs.el_arcctrl) {
      vue.$refs.el_arcctrl.onmousemove = function() {
        vue.$refs.el_arcctrl.setAttribute("showit","true");
        if (!vue.show_tid && !vue.allowpause) {
          vue.show_tid = setTimeout(function() {
            //console.log("ALLOW");
            vue.allowpause = true;
            delete vue.show_tid;
          }, 600);
        }
        clearTimeout(vue.hide_tid);
        vue.hide_tid = setTimeout(function() {
           //console.log("FIRE");
           if (!vue.$refs.el_arcctrl) { return; }
           vue.$refs.el_arcctrl.setAttribute("showit","false");
           vue.allowpause = false;
        },2000);
      }
    }    
    if (vue.src) {
      vue.playArchive();
    }
  },
  beforeDestroy() {
    let vue = this;
    // eslint-disable-next-line 
    window.vx_nav_callback("unmute_cbs",{});
    if (vue.player) {
       vue.player.destroy();
       delete vue.player;
    }
  },
  methods: {
    formatTime: function(n) {
      let h,m,s;
      if (!n || n < 0) { return "-"; }
      s = Math.trunc(n);
      m = Math.trunc(n/60);
      s -= (60*m);
      h = Math.trunc(m/60);
      m -= (60*h);
      if (s < 10) s = "0"+s;
      if (m < 10) m = "0"+m;
      if (h == 0) {
        return ""+m+":"+s;
      }
      return ""+h+":"+m+":"+s;
    },
    playStatus: function(rv) {
      let vue = this;
      if (!vue.paused && rv.paused) {
         console.log("playStatus: pause changed");
      }
      vue.paused = rv.paused || false;
      vue.toggle = !vue.toggle;
      if (rv.at) {
        if (rv.at < vue.prev_at) {
          //console.log("back",at,vue.prev_at);
          vue.is_live = false;
          vue.player.set_live(false);
        }
        vue.prev_at = rv.at;
        vue.at = vue.formatTime(rv.at);
        vue.$refs.el_at.innerHTML = vue.at;
        /* Hack to make Safari refresh work */
        if (vue.toggle) {
          vue.$refs.el_at.style.color = "#ffffff";
        } else {
          vue.$refs.el_at.style.color = "#fffffe";
        }
      }
      rv.max = rv.max || 0;
      vue.subtitles.has = rv.subtitles.has;
      vue.subtitles.show = rv.subtitles.show;
      if (rv.is_done) {
        if (vue.src) { vue.src.done = true; }
        vue.is_live = false;
        vue.player.set_live(false);
        vue.dur = 1000*rv.max;
      } else {
        vue.dur = Math.max(vue.dur,1000*rv.max);
      }
      vue.total = vue.formatTime(vue.dur/1000);
      vue.$refs.el_total.innerHTML = vue.total;
      vue.$set(vue,"cur_seg_name",(rv.seg_name || ""));
      vue.$set(vue,"cur_people",(rv.people || []));
      if (rv.seg_name || (rv.people && rv.people.length)) {
        vue.$set(vue,"show_info", true);
      } else {
        vue.$set(vue,"show_info", false);
      }

      /* Emit basic status to upper level */
      vue.pbmode = rv.pbmode;
      if (vue.$refs.el_arcctrl) {
         vue.$refs.el_arcctrl.setAttribute("pbmode",vue.pbmode);
      }
      vue.is_audio_only = rv.is_audio_only || false;
      if (vue.$refs.el_arcctrl) {
         vue.$refs.el_arcctrl.setAttribute("aonly",vue.is_audio_only);
      }
      vue.$emit("status", {
        is_done: rv.is_done,
        is_live: vue.is_live,
        pbmode: rv.pbmode,
        can_clip: rv.can_clip,
        has_clip: rv.has_clip,
        clip_cnt: rv.clip_cnt,
        has_subtitles: rv.subtitles.has,
      });
    },
    playHov: function(per,at,x,y,right,seg) {
      let vue = this;
      let h = "";
      h += vue.formatTime(at);
      if (seg) {
         h += " ("+seg.cnt+")";
      }
      if (seg && seg.name) {
         h += " - "+seg.name;
      }
      // Shows elapsed time of mouse pointer hover
      // return;
      vue.hov_el.style = {};
      if (per < 0.5) {
         vue.hov_el.style.left = x+"px";
      } else {
         vue.hov_el.style.left = (x-(5*h.length))+"px";
      }
      vue.hov_el.style.top = (y-25)+"px";
      vue.hov_el.innerHTML = h;
    },
    doPlayPause: function(ev) {
      let vue = this;
      if (vue.paused) {
         vue.player.play(ev);
      } else {
         if (vue.allowpause) {
           vue.player.pause(ev);
         }
      }
    },
    doPlay: function(ev) {
      let vue = this;
      vue.player.play(ev);
    },
    doLive: function() {
      let vue = this;
      vue.is_live = !vue.is_live;
      vue.player.set_live(vue.is_live);
    },
    toggleSub: function() {
      let vue = this;
      vue.player.toggle_subtitles();
    },
    doPause: function() {
      let vue = this;
      vue.player.pause();
    },
    doUnmute: function(ev) {
      if (!this.player) {
        window.vx_nav_callback("unmute",false);
        return;
      }
      this.player.mute(ev,false);
      window.vx_nav_callback("unmute",true);
    },
    doMute: function() {
      window.vx_nav_callback("unmute",false);
      if (!this.player) {
        return;
      }
      this.player.mute(null,true);
    },
    playArchive: function() {
      let vue = this;
      let ar = vue.src;
      if (!ar) {
         return;
      }
      vue.is_live = false;
      vue.prev_at = 0;
      vue.dur = ar.dur;
      if (vue.player) { vue.player.destroy(); }
      let vxArc = ap();
      vue.player = new vxArc();

      let opt = {};
      if (!window.__arcvideo) {
        if (window.MediaSource.name != "jsMSE") {
          let v = document.createElement("video");
          v.muted = true;
          v.autoPlay = false;
          window.__arcvideo = v;
          //console.log("Created arc video player",v);
        } else {
          let v = document.createElement("canvas");
          v.muted = true;
          v.autoPlay = false;
          window.__arcvideo = v;
          //console.log("Created arc video player",v);
        }
      } else {
        //console.log("Reusing video player",window.__arcvideo);
      }
      vue.$refs.arcplay.appendChild(window.__arcvideo);
      opt.vel = window.__arcvideo;
      opt.pel = vue.$refs.progbar;
      vue.hov_el = vue.$refs.seekhov;
      opt.url = ""+ar.url;
      opt.dur = ar.dur/1000;
      opt.cb = vue.playStatus;
      opt.hov_cb = vue.playHov;
      vue.player.init(opt);

      /* Unmute if previously unmuted */
      if (window.__arcvideo.getAttribute("canunmute")) {
        vue.doUnmute();
      } else {
        vue.doMute();
      }

      /* Play if previously played */
      if (window.__arcvideo.getAttribute("canplay")) {
        vue.doPlay();
      }

      /* Default to Live if not done */
      if (!ar.done) {
        vue.doLive();
      }
      vue.$emit("player", vue.player);
    },
  },
}
</script>

<style lang="scss" scoped>

.arccontainer {
  position: relative;
  padding:0;
  min-width:300px;
  width:100%;
  height:100%;
}

.arcplay {
  display:flex;
  align-items: center;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
}

.arcctrl {
  position:absolute;
  top: 0px;
  left: 0px;
  width:100%;
  height:100%;
}

#arc_wall {
  width: 100%;
  max-height: calc(100vh - 100px);
  object-fit:contain;
}

.pbtop {
  position:absolute;
  bottom:5px;
  line-height:0;
  margin:0.1rem 1rem;
}

.pbmsg {
  width:100%;
  line-height: 1rem;
  text-align: center;
  font-size: 0.7rem;
  letter-spacing: 0.06rem;
  color: white;
  text-shadow: 0 0 1em black, 0 0 0.5em black, 0.07em 0 black, 0 0.07em black, -0.07em 0 black, 0 -0.07em black;
  opacity:0;
}

.pbrow {
  display:flex;
  flex-direction:row;
  height: 20px;
  padding-right:0.5rem;
  border-radius: 5px;
  background-color: rgba(0,0,0,0.9);
  opacity:0;
}

.arcctrl[showit="true"] .pbrow {
  opacity: 1;
  transition: opacity 250ms ease-out 250ms;
}
.arcctrl[showit="true"] .pbmsg {
  opacity: 1;
  transition: opacity 250ms ease-out 250ms;
}
.arcctrl[pbmode="clip_select"] .pbrow {
  opacity: 1;
}
.arcctrl[pbmode="clip_select"] .pbcore {
  cursor: pointer;
}
.arcctrl[pbmode="clip_start"] .pbcore {
  cursor: pointer;
}
.arcctrl[pbmode="clip_end"] .pbcore {
  cursor: pointer;
}
.arcctrl[aonly="true"] .pbrow {
  opacity: 1;
}

.bigmat {
  position: absolute;
  left: calc(50% - 5rem);
  top: calc(40% - 5rem);
  font-family: 'Material Icons';
  font-size: 10rem;
  color:white;
  background-color: transparent;
  text-shadow: 0 0 1em black, 0 0 0.5em black;
  cursor: pointer;
}

.pbitem {
  flex: 0 0 35px;
  align-self: center;
  border: none;
  background: none;
  color: white;
  outline: none;
  padding: 0.3rem;
}

.pbbtn {
}

.pbmat {
  font-family: 'Material Icons';
  font-size: 25px;
  max-width: 35px;
  line-height: 1;
}

.pbelp {
  font-size:0.75rem;
  text-align:center;
}

.pbcore {
  flex: 1 1 auto;
  /*margin: auto;*/
  display:flex;
}

.txtdone {
  background: rgba(0,0,0,0.75);
  font-weight: bold;
  border: solid 2px black;
  border-radius: 5px;
}

#arc_pb {
  background-color:transparent;
  width:99%;
  height:0.5rem;
}

.pbdone {
  color: white;
  background-color:#101050;
  font-size: 0.7rem;
  border-radius:0.25rem;
  margin:0.2rem;
  min-height:20px;
}

.pblive {
  color: #aaaaaa;
  font-size: 0.7rem;
  border-radius:0.25rem;
  margin:0.2rem;
  min-height:20px;
}

.pblive[enabled="true"] {
  background-color: red;
  font-weight: 700;
}

.pbsub {
  font-family: 'Material Icons';
  color: #909090;
  font-size: 1.1rem;
  max-width: 1.5rem;
  line-height: 1.3rem;
  border-radius:0.25rem;
  margin: 0;
  padding: 0;
}

.seekhover {
  position:fixed;
  line-height:1.2rem;
  font-size:0.7rem;
  color:white;
  background-color:#202020;
  padding: 0 3px;
  border-radius:5px;
  border: 1px solid #909090;
  opacity:0;
}

.pbcore:hover > .seekhover {
  opacity:1;
  transition: 0.2s;
}

.vinfo {
  position:absolute;
  top: 1rem;
  left: 1rem;
  min-width: 30%;
  background-color: rgba(0,0,0,0.7);
  padding: 0.5rem;
  border-radius: 5px;
  opacity:0;
}

.arcctrl[showit="true"] .vinfo {
  opacity:1;
  transition: opacity 250ms ease-out 250ms;
}

.vinfo-seg {
  line-height:1.2rem;
  font-size:1rem;
  color:white;
  text-decoration: underline;
  font-weight: bold;
}

.vinfo-person {
  line-height:1.2rem;
  font-size:0.9rem;
  color:white;
}

@media screen and (max-width:600px) and (orientation:portrait) {
  .pbrow {
     height:30px;
  }
  .pbitem {
     padding: 0.15rem;
  }
}

</style>